import React, { useEffect, useState } from 'react';
import './game-data-display.styles.scss';
import UserInfoCol from '../user-info-col/user-info-col.component';
import { useSelector } from 'react-redux';
import useWindowResize from '@/utils/windowSize';
import { faChartLine, faChartSimple } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeLinkActive } from '@/utils/active-links';
import UserDataDisplay from './user-data-display.component';

const GameDataDisplay = ({
  leaders,
  matchups
}) => {

  const userProfile = useSelector(state => state.userData.profile);
  const [width, height] = useWindowResize();
  const [ viewing, setViewing ] = useState('user');
  // style={{height: height-245}}

  useEffect(() => {
    makeLinkActive('game-data-link');
  }, [])

  return (
    <div className='game-data-display'>
      <div
        className='g-box data-box' >
        <div className='main-head'>
          <div>
            <FontAwesomeIcon 
              icon={faChartSimple} 
              className='head-icon' />
            Game Data
          </div>
        </div>
        <hr />
        {/* <div className='top-buttons'>
          <button 
            className={`g-button medium-btn ${viewing === 'user' ? '' : 'inactive'}`} 
            onClick={() => setViewing('user')}>
            Your Data
          </button>
          <button 
            className={`g-button medium-btn ${viewing === 'overall' ? '' : 'inactive'}`} 
            onClick={() => setViewing('overall')}>
            Overall
          </button>
        </div> */}
        <div className="g-space-1"></div>
        {
          (viewing === 'user') 
          ?
          <UserDataDisplay
            leaders={leaders}
            matchups={matchups} />
          :
          <div>Overall stats</div>
        }
      </div>
    </div>
  )
}

export default GameDataDisplay